import { c as _c } from "react/compiler-runtime";
import { getListStatus } from "@components/table/members/remove-xg-seat/remove-xg-seat-utils";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { allMemberTeamsSelector, memberTeamsStatusSelector } from "@store/teams/teams-selector";
import { resetMemberTeams } from "@store/teams/teams-slice";
import { fetchTeams } from "@store/teams/teams-slice-thunk";
import { useEffect } from "react";
/**
 * Fetches the teams a member belongs to, freshly every time it is used, since what the user did
 * meanwhile may have changed them.
 *
 * @param memberIdentity The identity of the member
 */
export function useMemberTeams(memberIdentity) {
  const $ = _c(9);
  const dispatch = useAppDispatch();
  const teams = useAppSelector(allMemberTeamsSelector);
  const status = useAppSelector(memberTeamsStatusSelector);
  let t0;
  let t1;
  if ($[0] !== dispatch || $[1] !== memberIdentity) {
    t0 = () => {
      dispatch(resetMemberTeams());
      const request = dispatch(fetchTeams({
        memberIdentity
      }));
      return () => {
        request.abort();
        dispatch(resetMemberTeams());
      };
    };
    t1 = [dispatch, memberIdentity];
    $[0] = dispatch;
    $[1] = memberIdentity;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== status) {
    t2 = getListStatus(status);
    $[4] = status;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2 || $[7] !== teams) {
    t3 = {
      teams,
      status: t2
    };
    $[6] = t2;
    $[7] = teams;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}